import * as Jsx from './gaauth.jsx'
const RxComponent = global.rootRequire('components/shares/rxComponent').default

class gaauthComponent extends RxComponent {
  constructor (props, context) {
    super(props, context, Jsx)
    this.state = {}
  }

  onClickDataNew (e) {
    global.scrolltop()
    const clone = {
      name: 'GA Auth ' + new Date().toLocaleString(),
      xsrf_token: '',
      secure_psid: '',
      secure_psidts: '',
      is_active: 1,
      is_deleted: 0,
      created_at: 1
    }
    e.inthis.setState({ editingData: clone })
  }

  render () { return this.renderComponent() }
}

export default gaauthComponent
